import { render } from "./ModalWork.vue?vue&type=template&id=14b9e770&ts=true"
import script from "./ModalWork.vue?vue&type=script&lang=ts"
export * from "./ModalWork.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__